export default "__VITE_ASSET__5_yGd4zc__"